import {
  CategoryName,
  DisplayModeName,
  IInParamsValues,
} from '@infotech-soe/metaschema';
import { legacy_connect as connect } from 'react-redux';

import { CategoryOpenMode } from '../../../../models/category/category';
import { IPanelLink } from '../../../../models/dataset/DatasetRelated';
import { AppDispatch } from '../../../../store';
import { AppState } from '../../../../store/reducers/root';
import { hasDisplayModeContentTab } from '../../../../store/selectors/content';
import { getPanelLinksConfig } from '../../../../store/selectors/userConfig';
import categoryActions from '../../../../store/slices/category';
import content from '../../../../store/slices/content';
import menu from '../../../../store/slices/menu';
import userConfig from '../../../../store/slices/userConfig';

import PanelLinks from './PanelLinks';

const mapStateToProps = (state: AppState) => ({
  isAlreadyOpen: (
    categoryName: CategoryName,
    displayModeName: DisplayModeName
  ) => hasDisplayModeContentTab(state, categoryName, displayModeName),
  panelLinks: getPanelLinksConfig(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onActivateDisplayMode: (
    categoryName: CategoryName,
    displayModeName: DisplayModeName
  ) =>
    dispatch(
      content.activateDisplayMode({
        category: categoryName,
        displayMode: displayModeName,
      })
    ),
  onCloseMenu: () => dispatch(menu.toggleOpened(false)),
  onGetPanelLinks: () => dispatch(userConfig.getPanelLinks()),
  onOpenDisplayMode: (
    categoryName: CategoryName,
    displayModeName: DisplayModeName,
    inParams?: IInParamsValues,
    action?: string,
    withDefaultConfig?: boolean
  ) =>
    dispatch(
      categoryActions.openDisplayMode({
        category: categoryName,
        displayMode: displayModeName,
        ui: {
          mode: action ? CategoryOpenMode.HIDDEN : CategoryOpenMode.CONTENT,
        },
        inParams,
        nextAction: action,
        withDefaultConfig,
      })
    ),
  onSavePanelLinks: (links: IPanelLink[]) =>
    dispatch(userConfig.savePanelLinks(links)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelLinks);
